import React from "react";
import { FiSearch } from "react-icons/fi";

interface FoodItemsFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  sortBy: "occurrences" | "calories" | "name" | "protein" | "carbs" | "fat";
  onSortChange: (
    value: "occurrences" | "calories" | "name" | "protein" | "carbs" | "fat",
  ) => void;
}

export default function FoodItemsFilters({
  searchTerm,
  onSearchChange,
  sortBy,
  onSortChange,
}: FoodItemsFiltersProps) {
  return (
    <div className="mb-4 sm:mb-6 flex flex-col gap-3 sm:gap-4 sm:flex-row">
      {/* Barra de Busca */}
      <div className="relative flex-1">
        <FiSearch
          className="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 text-gray-400"
          size={16}
        />
        <input
          type="text"
          placeholder="Buscar alimento..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full rounded-lg border border-stroke bg-white py-2 sm:py-2.5 pl-9 sm:pl-11 pr-3 text-xs sm:text-sm font-medium outline-none transition focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 dark:border-strokedark dark:bg-form-input dark:text-white dark:focus:border-purple-500"
        />
      </div>

      {/* Filtro de Ordenação */}
      <div className="relative w-full sm:w-56">
        <select
          value={sortBy}
          onChange={(e) =>
            onSortChange(
              e.target.value as
                | "occurrences"
                | "calories"
                | "name"
                | "protein"
                | "carbs"
                | "fat",
            )
          }
          className="relative w-full appearance-none rounded-lg border border-stroke bg-white py-2 sm:py-2.5 pl-3 pr-8 sm:pr-9 text-xs sm:text-sm font-medium text-gray-700 outline-none transition focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 dark:border-strokedark dark:bg-form-input dark:text-white dark:focus:border-purple-500"
        >
          <option value="occurrences">Por Consumo</option>
          <option value="calories">Por Calorias</option>
          <option value="protein">Por Proteína</option>
          <option value="carbs">Por Carboidratos</option>
          <option value="fat">Por Gorduras</option>
          <option value="name">Por Nome</option>
        </select>
        <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
          <svg className="h-4 w-4 fill-current" viewBox="0 0 24 24">
            <path d="M7 10l5 5 5-5H7z" />
          </svg>
        </span>
      </div>
    </div>
  );
}
